import React from "react"
import PostEditButton from "../PostEditButton"
import { ManageTicketsButton } from "../posts/ManageTicketsButton"
import { SendAdvanceButton } from "./SendAdvanceButton"
import { Band } from "../../types/bands"
import { Concert } from "../../types/events"

interface EditManageHeaderProps {
  isOwner: boolean
  post: Concert & { id: number }
  setShowEditForm: (show: boolean) => void
  band?: Band
}

export const EditManageHeader: React.FC<EditManageHeaderProps> = ({
  isOwner,
  post,
  setShowEditForm,
  band,
}) => {
  if (!isOwner) {
    return null
  }

  return (
    <div className="bg-yellow-600 flex items-baseline text-white mb-2 gap-2 px-1">
      <PostEditButton setShowEditForm={setShowEditForm} />
      {post.ticket_type === "bNTickets" && (
        <ManageTicketsButton postId={post.id} />
      )}
      {band && <SendAdvanceButton band={band} concert={post} />}
    </div>
  )
}

export default EditManageHeader
